import api from './utilPartner';

const controller = 'ConfigCallback';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  LocalizarConfigCallback: (dto) => {
    return api.Axios.GetParams(url + '/LocalizarConfigCallback', dto);
  },
  AtualizarConfigCallback: function (dto) {
    return api.Axios.Post(`${url}/AtualizarConfigCallback`, dto);
  }
});
